import React, { useState } from "react";
import { postData } from "../../components/helpers/Data";
import MessageModal from "../../components/helpers/Modal2";
import { userSaveDetails } from "../../components/helpers/UserSaveDetails";

const Profile = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(3);

  const [messageModal, setIsMessageModal] = useState(false);
  const [response, setResponse] = useState([]);

  let user = sessionStorage.getItem("mwerezi_mpos_username");

  const validateInput = (e) => {
    e.preventDefault();
    const formData = new FormData(
      document.getElementById("change_password_form")
    );
    let strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );

    const new_password = document.getElementById("new_password").value;
    const confirm_new_password = document.getElementById(
      "confirm_new_password"
    ).value;
    const existing_password =
      document.getElementById("existing_password").value;
    let result = strongRegex.test(new_password);
    if (result) {
      if (new_password === confirm_new_password) {
        if (new_password !== existing_password) {
          savePasswordChange(formData);
        } else {
          setResponse(["New password cannot be the same as current password!"]);
          setIsMessageModal(true);
        }
      } else {
        setResponse(["New Password and confirm password must match!"]);
        setIsMessageModal(true);
      }
    } else {
      setResponse([
        "PASSWORD MUST MEET THE FOLLOWING REQUIREMENTS:",
        "1. A minimum of 8 characters",
        "2. At least one uppercase letter",
        "3. At least one lowercase letter",
        "4. At least one number",
        "5. At least one special character such as #, @, and $",
      ]);
      setIsMessageModal(true);
    }
  };

  const savePasswordChange = (frmData) => {
    //append access log details
    frmData.append("user_id", logData[0]);
    frmData.append("accessed_item", logData[1]);
    frmData.append("browser_type", logData[2]);
    frmData.append("os_type", logData[3]);

    postData(frmData, "save_profile_password_change")
      .then((data) => {
        if (data[0].includes("Error")) {
          console.log(data);
          setResponse(["Error updating password!"]);
        } else {
          setResponse(data);
        }
        setIsMessageModal(true);
      })
      .catch((error) => {
        console.log(error);
        setResponse(["Error updating password!"]);
        setIsMessageModal(true);
      });
  };
  //close message modal
  const closeMessageModal = () => {
    if (response[0].includes("Password updated successfully")) {
      window.location.reload();
    }
    setIsMessageModal(false);
  };

  return (
    <div>
      <section id="changepassword" className="project-tab">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <hr />
              <form
                className="claims_form mt-1"
                id="change_password_form"
                onSubmit={validateInput}
              >
                <fieldset>
                  <div id="invoice_details_1">
                    <h2 className="fs-title">Password Change</h2>
                    <hr />
                  </div>
                  <div className="row gap-2">
                    <input
                      type="text"
                      className="form-control"
                      name="username"
                      id="username"
                      placeholder="Existing User Name"
                      aria-required="true"
                      value={user}
                      required
                      readOnly
                    />

                    <input
                      type="password"
                      className="form-control"
                      name="existing_password"
                      id="existing_password"
                      placeholder="Existing Password"
                      aria-required="true"
                      required
                    />

                    <input
                      type="password"
                      className="form-control"
                      name="new_password"
                      id="new_password"
                      placeholder="New Password"
                      aria-required="true"
                      required
                    />

                    <input
                      type="password"
                      className="form-control"
                      name="confirm_new_password"
                      id="confirm_new_password"
                      placeholder="Confirm New Password"
                      aria-required="true"
                      required
                    />
                  </div>
                  <hr />
                  {/* Save button */}
                  <input
                    type="submit"
                    className="btn btn-success col-4"
                    value="Save"
                  />
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/*Message modal*/}
      <MessageModal
        modalIsOpen={messageModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={
          <span className="h4 text-white font-weight-bold text-center">
            {response.map((fb) => {
              return (
                <p className="h4 text-white font-weight-bold text-left">{fb}</p>
              );
            })}
          </span>
        }
      />
    </div>
  );
};

export default Profile;
